import React, { useState, useRef, useMemo } from "react";
import { Modal, message, Table, Alert, Tag, Space } from "antd";
import { lib } from "../../index";
import "./role-add-account-modal.less";
import SearchConditionList from "../../config-center-v3/search-list/search-condition-list";
import Immutable from "immutable";
import { CloseOutlined } from "@ant-design/icons";

const searchList = [
    {
        type: "input",
        label: "用户",
        key: "name",
        trimMode: "all",
        colProps: { span: 12 },
    },
];
export default function RoleAddAccountModal({ roleId, onClose, visible }) {
    let [pagination, setPagination] = useState({ pageSize: 10, currentPage: 1, totalCount: 1 });
    let [dataSource, setDataSource] = useState([]);
    let [loading, setLoading] = useState(false);
    let [selectedRows, setSelectedRows] = useState([]);
    let searchRef = useRef();
    const rowKey = "userId";
    const title = lib.config.webToken === "admin" ? "添加用户" : "添加员工";

    function fetchList(pagination) {
        const params = searchRef.current.getSearchCondition();
        setLoading(true);
        lib.request({
            url:
                lib.config.webToken === "admin"
                    ? "/ucenter-admin/role/user/unbind/page"
                    : "/ucenter-customer/role/user/unbind/page",
            data: {
                ...pagination,
                ...params,
            },
            needMask: true,
            success: res => {
                setLoading(false);
                setDataSource(res.dataList);
                setPagination(res.page);
            },
            fail: () => {
                setLoading(false);
            },
        });
    }

    function onSelect(record, selected) {
        select(record, selected);
    }

    function select(record, selected) {
        let recordKeyValue = record[rowKey];
        setSelectedRows(selectedRows => {
            if (selected && selectedRows.every(item => item[rowKey] !== recordKeyValue)) {
                return [...selectedRows, record];
            } else {
                return selectedRows.filter(item => item[rowKey] !== recordKeyValue);
            }
        });
    }

    function onSelectAll(selected, selectedRows, changeRows) {
        changeRows.forEach(item => {
            select(item, selected);
        });
    }

    function okHandle() {
        if (selectedRows.length < 1) {
            message.warn("请选择至少一条数据");
            return;
        }

        lib.request({
            url: lib.config.webToken === "admin" ? "/ucenter-admin/role/bind/user" : "/ucenter-customer/role/bind/user",
            data: { roleId, userIdList: selectedRowKeys },
            needMask: true,
            success: res => {
                onClose(true);
                message.success("添加成功！");
            },
        });
    }

    function afterClose() {
        setPagination({ pageSize: 10, currentPage: 1, totalCount: 1 });
        setSelectedRows([]);
    }

    function cancelHandle() {
        onClose();
    }

    function handleTableChange(pagination) {
        let page = {
            currentPage: pagination.current,
            pageSize: pagination.pageSize,
            totalCount: pagination.total,
        };
        setPagination(pagination);
        fetchList(page);
    }

    let addBatchColumns = [
        {
            title: "用户名",
            dataIndex: "userName",
            width: 150,
        },
        {
            title: "姓名",
            dataIndex: "nickName",
            width: 150,
        },
        {
            title: "创建时间",
            dataIndex: "createdAt",
        },
    ];
    const handleClose = removedTag => {
        const newTags = selectedRows.filter(tag => tag[rowKey] !== removedTag[rowKey]);
        setSelectedRows(newTags);
    };
    const forMap = tag => {
        return (
            <span
                key={tag[rowKey]}
                style={{
                    display: "inline-block",
                }}>
                <Tag
                    color={"#F6F7FA"}
                    closable
                    onClose={e => {
                        e.preventDefault();
                        handleClose(tag);
                    }}
                    closeIcon={<CloseOutlined style={{ color: "rgba(0, 0, 0, 0.85)" }} />}>
                    <span style={{ color: "rgba(0, 0, 0, 0.85)" }}>{tag.userName}</span>
                </Tag>
            </span>
        );
    };
    const header = useMemo(() => {
        const tagChild = selectedRows.map(forMap);
        return (
            <div>
                <Alert message={`您当前正在为${lib.getParam("page_title")}`} type="info" />
                <div className={"selected-tag"}>
                    <div className={"selected-tag-label"}>{title}：</div>
                    <div className={"selected-tag-content"}>
                        <Space wrap>{tagChild}</Space>
                    </div>
                </div>
            </div>
        );
    }, [selectedRows]);
    const selectedRowKeys = useMemo(() => {
        return selectedRows.reduce((prev, curr) => [...prev, curr[rowKey]], []);
    }, [selectedRows]);
    return (
        <Modal
            title={title}
            open={visible}
            maskClosable={false}
            destroyOnClose={true}
            onOk={() => okHandle()}
            onCancel={() => cancelHandle()}
            afterClose={afterClose}
            width={668}
            wrapClassName={"role-add-account-modal config-center-v3"}>
            {header}
            <div className={"search-list"}>
                {searchList?.length ? (
                    <div className={"search-condition-panel"}>
                        <SearchConditionList
                            ref={searchRef}
                            showMini={false}
                            defaultSearch={Immutable.Map({})} //重置会被清除
                            searchKeyList={searchList}
                            onSearch={(search, reset) => {
                                pagination.currentPage = 1;
                                fetchList(pagination);
                            }}
                        />
                    </div>
                ) : (
                    ""
                )}
                <Table
                    loading={loading}
                    dataSource={dataSource}
                    size={"small"}
                    columns={addBatchColumns}
                    scroll={{ x: "max-content", y: 350 }}
                    onChange={handleTableChange}
                    rowSelection={{
                        selectedRowKeys,
                        onSelect: onSelect,
                        onSelectAll: onSelectAll,
                    }}
                    rowKey={rowKey}
                    pagination={{
                        pageSize: pagination.pageSize,
                        current: pagination.currentPage,
                        total: pagination.totalCount,
                    }}
                />
            </div>
        </Modal>
    );
}
